<div class="modal-header bg-primary text-white">
    <h5 class="modal-title">Return Parts</h5>
    <button type="button" class="btn-close" (click)="close()"></button>
  </div>
  
  <div class="modal-body">
    <div *ngFor="let part of parts; let i = index" class="card mb-3 border">
      <div class="card-header d-flex align-items-center">
        <input
          type="checkbox"
          class="form-check-input me-2"
          [checked]="selectedParts.includes(part.enquiryPartId)"
          (change)="toggleSelection(part.enquiryPartId, $event)"
        />
        <div>
          <h5 class="mb-0">{{ part.partDescription }}</h5>
          <small><strong>Brand:</strong> {{ part.brand }}</small><br />
          <small><strong>Qty:</strong> {{ part.uptoRetQty }} | <strong>Price:</strong> ₹{{ part.price }}</small>
        </div>
      </div>
  
      <div class="card-body" *ngIf="selectedParts.includes(part.enquiryPartId)">
        <div class="mb-3">
          <label class="form-label">Return Qty</label>
          <input
            type="number"
            class="form-control"
            [(ngModel)]="returnQty[part.enquiryPartId]"
            [max]="part.uptoRetQty"
            (blur)="validateReturnQty(part.enquiryPartId, part.uptoRetQty)"
            placeholder="Enter return quantity"
          />
        </div>
  
        <div class="mb-3">
          <label class="form-label">Remarks</label>
          <textarea
            class="form-control"
            rows="2"
            [(ngModel)]="remarks[part.enquiryPartId]"
            [class.invalid]="showRemarkError[part.enquiryPartId]"
          ></textarea>
          <div class="error-message" *ngIf="showRemarkError[part.enquiryPartId]">
            Remarks is mandatory.
          </div>
        </div>
  
        <div class="mb-3" *ngIf="!part?.partAttachmentId && !part?.partImg">
          <button class="btn btn-outline-secondary w-100" (click)="addPartImage(i)">
            <i class="bi bi-cloud-upload me-2"></i> Upload Image
          </button>
        </div>
  
        <div class="d-flex align-items-center mb-3" *ngIf="part?.partAttachmentId && part?.partImg">
          <img
            [src]="part.partImg"
            class="img-thumbnail me-3"
            style="width: 80px; height: auto;"
            alt="Uploaded Image"
          />
          <div>
            <strong>Image Preview</strong><br />
            <small>{{ part.partImg.split('/').pop() }}</small><br />
            <button class="btn btn-sm btn-outline-primary mt-1" (click)="addPartImage(i)">
              <i class="bi bi-arrow-repeat me-1"></i> Replace Image
            </button>
          </div>
        </div>
      </div>
    </div>
  
    <button
      class="btn btn-success w-100"
      [disabled]="loading || !hasValidReturnData()"
      (click)="submitReturn()"
    >
      <span *ngIf="loading" class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
      <i *ngIf="!loading" class="bi bi-check-circle me-2"></i>
      {{ loading ? 'Submitting...' : 'Submit Return' }}
    </button>
  </div>
